import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './dashboard.css';
import Header from '../../components/common/header';
import Footer from '../../components/common/footer';
import { useUser } from '../../contexts/userContext';
import '../home/homePage.css';
import { useCart } from '../../contexts/cartContext';

// Define the Order interface
interface Order {
  order_id: number;
  user_id: number;
  order_no: string;
  coupon_code: string | null;
  coupon_type: string | null;
  coupon_value: string | null;
  total_value: string;
  created_by: number;
  updated_by: number | null;
  created_at: string;
  updated_at: string | null;
  status_id: number;
  evaluated_price: string | null;
  final_pay_amt: string | null;
  assigned_to: string | null;
  pickup_datetime: string | null;
  ip_address: string | null;
}

const DashboardPage = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState<Order[]>([]); // Typed as Order array
  const [haveWeReceivedPostResponseState, setHaveWeReceivedPostResponseState] = useState('not yet');
  const [csrfTokenState, setcsrdTokenState] = useState('');
 
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  // async function getcalltoform(){
  //   const url = 'form'
  //   let response = await fetch(`${backendUrl}${url}`,

  //     if (!response.ok) {
  //       //console.error("Error fetching cart items:", response.status, response.statusText);
        
  //       // Handle 403 Forbidden explicitly
  //       if (response.status === 403) {
  //         setError("Access forbidden: You don't have permission to view cart items.");
  //         localStorage.clear()
  //         sessionStorage.clear()
  //         navigate("/"); // Redirect to login if unauthorized
  //         return;
  //       }
  
  //       throw new Error(`HTTP error! Status: ${response.status}`);
  //     }
  //     const result = await response.json();
  //     //console.log("orsers--------66666",result.data)
  //     setOrders(result.data);
  //   } catch (err: any) {
  //     setError('Failed to fetch orders.');
  //   } finally {
  //     setLoading(false);
  //   }
  //   )
  //   let parsedResponse =await  fetchGetResponse.json()
  //   setcsrdTokenState(parsedResponse.csrfToken)
 
  // }


  // async function testcsrfpostclick(){
  //   const url = 'process'
  //   let fetchPost = await fetch("http://localhost:8000/process", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //       "X-CSRF-Token": csrfTokenState, // ✅ Send CSRF token
  //     },
  //     credentials: "include", // ✅ Required for cookies
  //     body: JSON.stringify({ message: "Hello, server!" }),
  //   });
  //   let parseResponse = await fetchPost.text();
  //   setHaveWeReceivedPostResponseState(parseResponse)
  // }


  // useEffect(() => {
  //    getcalltoform()
  // }, []);

  

  return (
    <div>
      {/* <button onClick={testcsrfpostclick}>Test post call server.</button>
      <p>csrf Token is: {csrfTokenState}</p>
      <p>Have we successfully navigated though post request?: {haveWeReceivedPostResponseState}</p> */}
     
    </div>
  );
};

export default DashboardPage;
